import React from 'react';
import Banner from "../Components/Shared/Layout/Banner";
import withLanguage from "../HOC/withLanguage";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import YoutubeEmbed from '../Components/Shared/Layout/YoutubeEmbed';
import VideoInfoGrid from "../Components/Shared/Layout/VideoInfoGrid";

const LearningAndPractice = ({ language }) => {

    return (
        <>
            <Banner img="/LearningAndPractice/banner.jpg" title={language.banner} />
            <IntroBlock>{language.intro}</IntroBlock>

            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <p className="text-lg">{language.p}</p>
                <VideoInfoGrid apiPath="mesimi_dhe_praktika"/>
            </div>
        </>
    );
};

export default withLanguage(LearningAndPractice, 'LearningAndPractice');